module.exports = __webpack_public_path__ + "img/Image-5.00bccad0.png";